'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    var selectedDeliveryNotes = [];

    $("[unconfirmed-delivery-notes-checkbox]", this).each(function () {
        //Once it is loaded, every checkboxes are checked by default - lets add them to our array
        var deliveryNoteId = $(this).attr('value');
        selectedDeliveryNotes.push(deliveryNoteId);
        $(this).on("click", function () {
            var deliveryNoteId = $(this).attr('value');
            var isChecked = $(this).prop('checked');
            if (isChecked && selectedDeliveryNotes.indexOf(deliveryNoteId) < 0) {
                selectedDeliveryNotes.push(deliveryNoteId);
            }
            if (!isChecked && selectedDeliveryNotes.indexOf(deliveryNoteId) >= 0) {
                selectedDeliveryNotes.splice(selectedDeliveryNotes.indexOf(deliveryNoteId), 1);
            }
        });
    });

    $(document).on('click', '[unpaid-delivery-notes-button-submit]', function () {
        _message2.default.confirm(Resx.App.ConfirmDeliveryNotesConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                deliverynoteService.confirmDeliveryNotes(selectedDeliveryNotes).done(function (result) {
                    selectedDeliveryNotes = [];
                    $('#unconfirmedDeliveryNotesTable,#unconfirmableDeliveryNotesTable').DataTable().ajax.reload(null, false);
                    _notify2.default.success(Resx.App.DeliveryNotesConfirmed);
                }).fail(function (result) {
                    _notify2.default.error(Resx.Common.AjaxError);
                });
            }
        });
    });
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Messages', 'Common');

var $ = require("jquery");
var deliverynoteService = abp.services.api.deliverynote;

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/unconfirmedDeliveryNotes.js
// module id = 1084
// module chunks = 1